import { keepPreviousData, useQuery } from "@tanstack/react-query";
import qs from "qs";
import { getCostChangeHistory } from "../api/RecipeApi";

const recipeCostChangeHistoryKeys = {
  all: ["recipeCostChangeHistory"],
  list: (recipeId, filters) => [
    ...recipeCostChangeHistoryKeys.all,
    recipeId,
    filters,
  ],
};

export const useCostChangeHistoryQueries = ({
  recipeId,
  pagination,
  sorting,
  debouncedSearch,
}) => {
  let params = {};

  if (debouncedSearch) {
    params = { ...params, search: debouncedSearch };
  }

  if (sorting?.length > 0) {
    const sortByParams = sorting.reduce(
      (obj, item) =>
        Object.assign(obj, { [item.id]: item.desc ? "desc" : "asc" }),
      {},
    );
    params = { ...params, sort: sortByParams };
  }

  const query = {
    params,
    paramsSerializer: (nextParams) =>
      qs.stringify(nextParams, { encode: true }),
  };

  const costChangeHistoryQuery = useQuery({
    queryKey: recipeCostChangeHistoryKeys.list(recipeId, { params, pagination }),
    queryFn: () => getCostChangeHistory({ id: recipeId, query, pagination }),
    placeholderData: keepPreviousData,
    enabled: Number(recipeId) > 0,
  });

  return { costChangeHistoryQuery };
};
